import React from 'react';
import styles from "./Send_message.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons';

const Send_message = ({
  text = "Send Message",
  onClick,
  type = "button",
  showArrow = true
}) => {
  return (
    <button
      type={type}
      className={`send_button`}
      onClick={onClick}
    >
      {text}
      {showArrow && (
        <div className="arrow-div">
          <FontAwesomeIcon icon={faArrowRightLong} className="arrow-text" />
        </div>
      )}
    </button>
  );
};

export default Send_message;
